module.exports = __webpack_public_path__ + "media/assets/facebook-sign-in-daa2fede82eec36ed48d7a2365014903.svg";